/* @ngInject */
const myDataDisplay = () => {
  return {
    restrict: 'E',
    scope: {
      myData: '=',
      myNature: '=',
      enableLocalSearch: '=?',
      enableTitle: '=?',
      enableBadges: '=?',
      enableButtons: '=?',
      enableExcel: '=?',
      enableLinks: '=?',
      enableBack: '=?',
      enableNewButton: '=?',
      myTrain: '=?',
    },
    template: require('./myDataDisplay.html'),

    /* @ngInject */
    controller: ($scope, utils, labels, entities) => {
      $scope.filteredData = utils.copy($scope.myData)
      $scope.title = labels[$scope.myNature].statements.list

      $scope.goNew = entities[$scope.myNature].go.new

      $scope.$watch('myData', () => {
        $scope.filteredData = utils.copy($scope.myData)
      }, true)
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myDataDisplay



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/tables/myDataDisplay.js